module.exports = '<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M13.96 1.067a2 2 0 0 1 3.577-.025l14.278 28.05A2 2 0 0 1 30.033 32H1.969a2 2 0 0 1-1.795-2.882L13.96 1.067zm.933 2.742L2.738 28.559A1 1 0 0 0 3.635 30H28.38a1 1 0 0 0 .892-1.453l-12.59-24.75a1 1 0 0 0-1.789.012zM17.8 27a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zm0-5.929c0 .513-.448.929-1 .929h-2c-.552 0-1-.416-1-.929V9.93c0-.513.448-.929 1-.929h2c.552 0 1 .416 1 .929V21.07z" fill="#F39C5C" fill-rule="evenodd"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/outline-warning-1.js
// module id = 1325
// module chunks = 14